import withLocaleContext from 'hoc/withLocaleContext';
import React, { PureComponent } from 'react';
import { FormattedMessage } from 'react-intl';

import { ExpandElement, List, TextContainer } from '../Footer.styles';

class StandardDataProcessingMbankNote extends PureComponent<Partial<ILocaleContext>, { isOpened: boolean }> {
  constructor(props) {
    super(props);
    this.state = {
      isOpened: false,
    };
  }

  clickHandler = () => {
    this.setState(prevState => ({ isOpened: !prevState.isOpened }));
  };

  render() {
    const { isOpened } = this.state;
    const { formatMessage } = this.props;

    return (
      <div className="data-processing-notice mbank-data-processing-notice">
        <TextContainer>
          <FormattedMessage id="footer.mbank.dataProcessing1a" />
          <FormattedMessage id="footer.mbank.dataProcessing1b" />
          {!isOpened && (
            <ExpandElement onClick={this.clickHandler}>
              <FormattedMessage id="footer.expand" />
            </ExpandElement>
          )}
        </TextContainer>
        {isOpened && (
          <div>
            <TextContainer>
              <FormattedMessage id="footer.mbank.dataProcessing2" />
              <a href="mailto:Inspektordanychosobowych@mbank.pl" target="_blank" rel="noreferrer">
                Inspektordanychosobowych@mbank.pl
              </a>
            </TextContainer>
            <TextContainer>
              <FormattedMessage id="footer.mbank.dataProcessing3" />
            </TextContainer>
            <TextContainer>
              <FormattedMessage id="footer.mbank.dataProcessing4" />
            </TextContainer>
            <TextContainer>
              <FormattedMessage id="footer.mbank.dataProcessing5" />
              <List>
                <li>
                  <FormattedMessage id="footer.mbank.dataProcessing6" />
                </li>
                <li>
                  <FormattedMessage id="footer.mbank.dataProcessing7" />
                </li>
              </List>
            </TextContainer>
            <TextContainer>
              <FormattedMessage id="footer.mbank.dataProcessing8" />
            </TextContainer>
            <TextContainer>
              <FormattedMessage id="footer.mbank.dataProcessing9" />
            </TextContainer>
            <TextContainer>
              <FormattedMessage id="footer.mbank.dataProcessing10" />
            </TextContainer>
            <TextContainer>
              <FormattedMessage id="footer.mbank.dataProcessing11" />
              <a href={formatMessage && formatMessage({ id: 'footer.uodoLink' })} target="_blank" rel="noreferrer">
                <FormattedMessage id="footer.uodoTxt" />
              </a>
            </TextContainer>
            <TextContainer>
              <FormattedMessage id="footer.mbank.dataProcessing12" />
              <a
                href={formatMessage && formatMessage({ id: 'footer.mbank.dataProcessing12.rodoLink' })}
                target="_blank"
                rel="noreferrer"
              >
                <FormattedMessage id="footer.mbank.dataProcessing12.rodoTxt" />
              </a>
              {isOpened && (
                <ExpandElement onClick={this.clickHandler}>
                  <FormattedMessage id="footer.colapse" />
                </ExpandElement>
              )}
            </TextContainer>
          </div>
        )}
      </div>
    );
  }
}
export default withLocaleContext(StandardDataProcessingMbankNote);
